/**
 * Returns the rich text, or '' when it shows no text. A card cleared in the admin editor can hold markup such as
 * "<p></p>", which would otherwise render an empty features box on the card.
 */
export function richTextOrEmpty(html: string | null | undefined): string {
  if (!html) {
    return '';
  }
  const text = html.replace(/<[^>]*>/g, '').replace(/&nbsp;| /g, '').trim();
  return text ? html : '';
}
